import "lightslider"

export default {
  init() {
    // JavaScript to be fired on the about page
  },
  finalize($) {
    // JavaScript to be fired on the about page, after the init JS
    $('#lightSlider, .lightSliders').lightSlider({
      item        : 1,
      auto        : true,
      loop        : true,
      pause       : 7000,
      gallery     : true,
      thumbItem   : 6,
      slideMargin : 0,
    });

    $('.ct-item__title').each(function() {
      let text = $(this).text();
      $(this).text(text.replace(/\//gi, " / "));
    });

    if(location.hash && location.hash.length) {
      setTimeout(() => {
        document.querySelector(location.hash).scrollIntoView()
      }, 1200);
    }
  },
};
